import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const CSOption = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  input[type='checkbox'] {
    + svg {
      color: #000000;
      width: 14px;
    }
  }
  .option-label {
    cursor: pointer;
    color: #000000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .employee-selection {
    display: flex;
    align-items: center;
    min-width: 0;
  }
`;

export const GroupContainer = styled(Box)`
  border-bottom: 1px solid var(--border-dark, #a2a7ab);
  margin-bottom: 20px;
  padding-bottom: 15px;
`;
